module.exports = __webpack_public_path__ + "img/man_fairy.f2ec632d.gif";